import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { formatTokenValue } from 'mewe/utils/format-token-value';
export default class WalletSend extends Component {
  @tracked amount = this.args.amount;
  @tracked walletAddress = this.args.walletAddress;

  get isSendDisabled() {
    return this.isInvalidAmount || !this.walletAddress;
  }

  get isInvalidAmount() {
    return parseFloat(this.amount) <= 0 || this.isInsufficientBalance;
  }

  get isInsufficientBalance() {
    return parseFloat(this.amount) > formatTokenValue(this.args.balance, { fixed: 2});
  }

  @action
  nextStep() {
    this.args.onNextStep(parseFloat(this.amount), this.walletAddress);
  }
}